import { createSelector } from 'reselect'

export const getDarkly = (state) => state.get('engagement').darkly || {}

export const getDarklyFlags = createSelector([getDarkly], (data) => data.get('flags'))

export const getPendoValue = createSelector([getDarkly], (data) => {
  const { initPando } = data.get('flags')
  return initPando
})
